import React, { Component, useEffect, useState } from 'react';
import '../styles/App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import img1 from '../assets/statistics.png'
import img2 from '../assets/clock.png'
import img3 from '../assets/card.png';
import img4 from '../assets/wings.png';
import img5 from '../assets/musical-notes.png';
import img6 from '../assets/placeholder.png';
import img7 from '../assets/megaphone.png';
import img8 from '../assets/star.png';
import nft1 from '../assets/carouselPics/1.png';
import nft2 from '../assets/carouselPics/2.png';
import nft3 from '../assets/carouselPics/3.png';
import nft4 from '../assets/carouselPics/4.png';
import nft5 from '../assets/carouselPics/9.png';
import nft6 from '../assets/carouselPics/6.png';
import nft7 from '../assets/carouselPics/7.png';
import nft8 from '../assets/carouselPics/8.png';
import nft9 from '../assets/carouselPics/9.png';
import nft10 from '../assets/carouselPics/10.png';
import hand from '../assets/hand.png';

const nftData = [
    {
        image: nft1,
    },
    {
        image: nft2,
    },
    {
        image: nft3,
    },
    {
        image: nft4,
    },
    {
        image: nft5,
    },
    {
        image: nft6,
    },
    {
        image: nft7,
    },
    {
        image: nft8,
    },
    {
        image: nft9,
    },
    {
        image: nft10,
    },
    {
        image: nft1,
    },
    {
        image: nft2,
    },
    {
        image: nft3,
    },
    {
        image: nft4,
    },
    {
        image: nft5,
    },
    {
        image: nft6,
    },
    {
        image: nft7,
    },
    {
        image: nft8,
    },
    {
        image: nft9,
    },
    {
        image: nft10,
    },
]

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

const About = () => {

    return (
        <div class="aboutMain-1">
            <div class="conT" data-aos="zoom-in" data-aos-duration="700">REVENUE PLAN</div>
            <p></p>
            <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Turn Music into Wealth: Earn with Bunda NFTs!</div>

            <div className='boxMain'>
                <div className='box2Main'>
                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img1} />
                        <div class="conT2" id="colorTxt3"> Average Expected Revenue <br /> <span className='amountNumber'>($ 138)</span></div>
                        <p><span className='bold'></span> When purchasing 8 NFTs, one device
                            is matched 1:1, and the revenue
                            generated from equipment rental
                            amounts to $138 (approximately
                            160,000 KRW) per month. This can be
                            received either in USDT or MSC meme
                            coins.</p>
                    </div>

                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img2} />
                        <div class="conT2" id="colorTxt3">Expected Average Break-Even Period <br /> <span className='amountNumber'>(M/24 +)</span></div>
                        <p><span className='bold'></span> NFT holders aim to reach the break-
                            even point (BEP) within 24 months
                            from the time of ownership through
                            a combination of revenue streams,
                            including equipment rental revenue,
                            shared hotel room rental revenue,
                            and music royalties. Equipment
                            rental revenue is provided to holders
                            in various integrated ways.</p>
                    </div>
                </div>

                <div className='box2Main' data-aos="zoom-in" data-aos-duration="700">
                    <div class="boxAbout">
                        <img src={img3} />
                        <div class="conT2" id="colorTxt3">Revenue from NFT Character IP <br /> <span className='amountNumber'>(100%)</span></div>
                        <p><span className='bold'></span> The character you purchase
                            allows the holder to receive 100%
                            of the IP revenue generated
                            through the distribution and sales
                            of the IP. Users can leverage it
                            within a transparent and fair NFT
                            community.</p>
                    </div>

                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img4} />
                        <div class="conT2" id="colorTxt3">Benefits That Grow as More Angels Gather <br /> <span className='amountNumber'>(Membership)</span></div>
                        <p><span className='bold'></span> Membership is granted based on
                            the quantity of Bunda Angels NFTs
                            owned, providing special privileges
                            such as accommodations, travel
                            benefits, and regular giveaways.
                            The first membership tier is
                            awarded when holding three or
                            more NFTs.</p>
                    </div>
                </div>
            </div>

            <div className="carousel">
                <div className="carousel-images">
                    {nftData.concat(nftData).map((item, index) => (
                        <img key={index} src={item.image} alt={`NFT ${index + 1}`} />
                    ))}
                </div>
            </div>

            <div className='boxMain'>
                <div className='box2Main'>
                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img5} />
                        <div class="conT2" id="colorTxt3"> Participation in Music and Album Production<br /> <span className='amountNumber'>(MSC MEME COIN)</span></div>
                        <p><span className='bold'></span> By participating in music pro
                            duction with MSC coins, users
                            can gain decentralized revenue
                            from intellectual property rights,
                            performance rights, and repro
                            duction rights. Additionally, MSC
                            coins can be used for access to
                            theme park facilities and treasure
                            hunt activities.</p>
                    </div>

                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img6} />
                        <div class="conT2" id="colorTxt3">Access to Theme Park and Hotel Facilities<br /> <span className='amountNumber'>(EXTRA LARGE SCALE)</span></div>
                        <p><span className='bold'></span>Bunda Music's theme park plans
                            to start in Korea and expand to
                            Japan, China, Vietnam, Laos,
                            Malaysia, and Indonesia, ultima -
                            tely developing and operating
                            theme park sites in the United
                            States.</p>
                    </div>
                </div>

                <div className='box2Main' data-aos="zoom-in" data-aos-duration="700">
                    <div class="boxAbout">
                        <img src={img7} />
                        <div class="conT2" id="colorTxt3">SNS Advertising and IP Revenue<br /> <span className='amountNumber'>(OFFICIAL CHANNEL MANAGEMENT)</span></div>
                        <p><span className='bold'></span>Funds raised through Bunda Angels
                            NFTs will be utilized to grow SNS
                            channels. The revenue generated
                            from these channels will be used to
                            purchase meme coins on exchanges,
                            aiming to maintain and increase
                            their value without any price
                            manipulation.</p>
                    </div>

                    <div class="boxAbout" data-aos="zoom-in" data-aos-duration="700">
                        <img src={img8} />
                        <div class="conT2" id="colorTxt3">The World's Largest Star Audition<br /> <span className='amountNumber'>(STAR BATTLE)</span></div>
                        <p><span className='bold'></span>Bunda Music, leveraging its ex-
                            perience in organizing Superstar
                            K, which attracted 560,000
                            audition participants, conducts
                            global auditions and discovers
                            and nurtures stars through its
                            proprietary Dapp.</p>
                    </div>
                </div>
            </div>
            <img className='hand' src={hand} />
        </div>
    )
}

export default About;

